export default __webpack_public_path__ + "static/glass-6-cf14be85dc586befff36d5c7f910be0e.jpg";